import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
  chipContainer: css({
    display: "inline-flex",
    padding: '2px 10px 2px 10px',
    alignItems: "center",
    boxSizing: "border-box",
    background: Color.gradient[100],
    borderRadius: 16,
    pointerEvents: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      background: Color.danger[300],
    },
  }),
  chipLabel: css({
    color: Color.neutral[0],
    fontFamily: "roboto",
    fontSize: "12px",
    fontWeight: "normal",
    letterSpacing: "0px",
    marginRight: "10px",
  }),
  chipCloseButton: css({
    cursor: 'pointer',
    pointerEvents: "auto",
    width: 16,
    height: 16,
    color: Color.neutral[0],
    "&:hover": {
      background: 'transparent',
    },
  })
});
